import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./private-route";
import Layout from "../layouts/layout";

import LandingPage from "../pages/landingPage";
import LoginPage from "../pages/loginPage";
import MapPage from "../pages/mapPage";
import RateCalculatorPage from "../pages/rateCalculatorPage";
import PastToursPage from "../pages/pastToursPage";
import ProfilePage from "../pages/profilePage";
import NotFound from "../pages/notFound";

const Router = () => {
    return(
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<LandingPage />} />

                <Route path="login" element={<LoginPage />} />
                
                <Route element={<PrivateRoute />}>
                    <Route path="map" element={<MapPage />} />
                    <Route path="calculator" element={<RateCalculatorPage />} />
                    <Route path="records" element={<PastToursPage />} />
                    <Route path="profile" element={<ProfilePage />} />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}

export default Router;